import React, { useContext, useState } from "react";
import {
  Button,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

import { AuthenticationContext } from "../../auth/AuthProvider";

const SignInForm = ({ onSwitchToSignUp }) => {
  const authc = useContext(AuthenticationContext);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorInfo, setErrorInfo] = useState({ error: false, message: "" });
  const [pwdVisibility, setPwdVisibility] = useState(false);
  /* const [loggedIn, setLoggedIn] = useState(false); */

  const onLogin = (e) => {
    e.preventDefault();

    authc
      .login(email, password)
      .catch((e) => {
        setErrorInfo({
          error: true,
          message:
            "There was an error signing with the credentials used. Remember both fields are case sensitive.",
        });
      });
  };

  const togglePwdVisibility = () => setPwdVisibility(!pwdVisibility);

  return (
    <form noValidate>
      <Grid container spacing={2} textAlign="center">
        <Grid item xs={12}>
          <Typography variant="h6">Sign in</Typography>
        </Grid>

        <Grid item xs={12}>
          <div className="inputs-card">
            <TextField
              id="emailAddress"
              label="Username"
              required
              fullWidth
              size="small"
              type="text"
              InputProps={{ inputProps: { autoComplete: "on" } }}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <TextField
              id="password"
              label="Password"
              required
              fullWidth
              size="small"
              type={pwdVisibility ? "text" : "password"}
              InputProps={{
                inputProps: { autoComplete: "on" },
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle visibility"
                      onClick={togglePwdVisibility}
                    >
                      {pwdVisibility ? <VisibilityOffIcon /> : <VisibilityIcon />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
        </Grid>

        {errorInfo.error && (
          <Grid item xs={12}>
            <Typography color="error" variant="caption">
              {errorInfo.message}
            </Typography>
          </Grid>
        )}

        <Grid item xs={12}>
          <Button
            variant="contained"
            color="primary"
            className="buttons"
            onClick={onLogin}
            type="submit"
            disabled={!email.length || !password.length}
          >
            SIGN IN
          </Button>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body2" color="text.secondary">
            Don't have an account?{" "}
            <Button
              color="primary"
              size="small"
              onClick={onSwitchToSignUp}
              sx={{ textTransform: "none", p: 0, minWidth: "auto" }}
            >
              Sign Up
            </Button>
          </Typography>
        </Grid>
      </Grid>
    </form>
  );
};

export default SignInForm;
